module.exports = __webpack_public_path__ + "66c2c91203b585b7a6ea5fd57a734630.jpg";


/*****************
 ** WEBPACK FOOTER
 ** ../images/speakers/david-blurton.jpg
 ** module id = 406
 ** module chunks = 0
 **/